import { Card, Button, Container } from 'react-bootstrap';
import { NewsItem } from '../models/models';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { formatDate } from '../services/date';


export const NewsSection = ({ data = undefined, handleOnClick }: { data?: NewsItem[], handleOnClick: (newsItem: NewsItem) => void }) => {
  if (!data) return null;

  return (
    <section id="news" className="bg-primary pb-5">
      <Container className="my-5">
        <h2 className="text-white mb-3">News</h2>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {data.map((newsItem, index) => (
            <SwiperSlide key={index}>
              <Card className="shadow">
                {newsItem.imageOriginal && (
                  <Card.Img
                    height="auton"
                    variant="top"
                    src={newsItem.imageOriginal}
                    alt={newsItem.summary}
                    className="object-fit-contain"
                  />
                )}
                <Card.Body>
                  <Card.Title>{newsItem.title}</Card.Title>
                  <Card.Text>
                    <strong className="d-block">{formatDate(newsItem.date)}</strong>
                    {newsItem.summary}
                  </Card.Text>
                  <Button variant="primary" onClick={() => handleOnClick(newsItem)}>
                    Read more
                  </Button>
                </Card.Body>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};
